import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import {
	IMethodRoles,
	InfoPermissions,
	IRoles,
	IResources,
} from 'projects/access-control/src/app/Domain/Entities/roles.interface';
import { Subject } from 'rxjs';

@Directive({
	selector: '[appRole]',
})
export class RolesDirective {
	roles: IRoles[] = [] as IRoles[];
	destroy$ = new Subject<void>();
	val: IMethodRoles = {} as IMethodRoles;
	permissions: InfoPermissions[] = [];
	constructor(private templateRef: TemplateRef<any>, private viewContainer: ViewContainerRef) {}

	@Input()
	set appRole(val: IMethodRoles) {
		this.val = val;
		this.permissions = val.permissions;
		this.updateView();
	}

	updateView() {
		const roles: IRoles[] = this.getTotalRoles(this.val.view, this.val.permissions || []);
		const resources: IResources[] = this.getTotalResources(roles, this.val.view);
		this.validateAccess(resources, this.val.access);
	}

	getTotalRoles(view: string, permissions: InfoPermissions[]) {
		const roles: IRoles[] = [] as IRoles[];
		this.getRoles(permissions).forEach((role) => {
			if (role.resources.find((item) => item.name.toLowerCase() === view.toLowerCase())) {
				roles.push(role);
			}
		});
		return roles;
	}

	getRoles(permissions: InfoPermissions[]): IRoles[] {
		const host = document.location.hostname;
		const permissionsData = permissions.find(
			(item) => item.host === host && item.name.toLocaleLowerCase().includes('bis')
		) as InfoPermissions;
		return permissionsData?.roles || [];
	}

	getTotalResources(roles: IRoles[], view: string): IResources[] {
		const resources: IResources[] = [];
		roles.forEach((role) => {
			role.resources.forEach((resource) => {
				if (resource.name.toLowerCase() === view.toLowerCase()) {
					resources.push(resource);
				}
			});
		});
		return resources;
	}

	validateAccess(resources: IResources[], access: string[]) {
		let view = false;
		if (access.includes('ALL')) {
			view = true;
			this.viewContainer.clear();
			this.viewContainer.createEmbeddedView(this.templateRef);
		} else {
			access.forEach((accessItem) => {
				const item = resources.find((resouce) => resouce.action.includes(accessItem));
				if (item && !view) {
					view = true;
					this.viewContainer.clear();
					this.viewContainer.createEmbeddedView(this.templateRef);
				}
			});
		}
	}
}
